import { init, replayIntegration, setTag, thirdPartyErrorFilterIntegration } from '@sentry/react';
import { FeatureToggle, isFeatureEnabled } from '../../../assets/js/util/featureToggle';

export default class Sentry {
    static #instance: Sentry | null = null;

    public static getInstance(): Sentry {
        if (this.#instance === null) {
            this.#instance = new Sentry();
        }

        return this.#instance;
    }

    public static destroyInstance(): void {
        this.#instance = null;
    }

    public constructor() {
        init({
            dsn: process.env.SENTRY_DSN_REACT,
            replaysSessionSampleRate: 0,
            replaysOnErrorSampleRate: 0.1,
            integrations: [
                replayIntegration(),
                process.env.SENTRY_APP_KEY
                    ? thirdPartyErrorFilterIntegration({
                          filterKeys: [process.env.SENTRY_APP_KEY],
                          behaviour: 'drop-error-if-exclusively-contains-third-party-frames'
                      })
                    : undefined
            ].filter(Boolean),
            ignoreErrors: ['TurnstileError']
        });

        const isLandlord = document.body.classList.contains('userIsLandlord');
        setTag('is-landlord', isLandlord.toString());

        const env = document.documentElement.dataset.deploymentEnv;
        if (env) {
            setTag('deployment-environment', env);
        }

        const featuresEnabled = Object.values(FeatureToggle)
            .map((feature): string => (isFeatureEnabled(feature) ? feature : ''))
            .filter(Boolean);

        if (featuresEnabled.length) {
            setTag('features-enabled', featuresEnabled.join(','));
        }
    }
}
